import { HttpMethods, pushGaEvent } from "@kvix/shared";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
import React, { useEffect, useRef, useState } from "react";
const useStyles = makeStyles(() => ({
    poster: {
        "& div:not(.vjs-has-started) .theo-player-wrapper": {
            backgroundSize: "cover",
            backgroundImage: ({ image }) => (image ? `url("${image}")` : "none")
        },
        "& .theo-player-wrapper": {
            display: ({ canPlay }) => (canPlay ? "block" : "none")
        },
        "& div:not(.vjs-has-started) .theo-player-wrapper .vjs-tech": {
            opacity: ({ image }) => (image ? 0 : 1)
        }
    },
    container: {
        "& .theo-player-wrapper > .theo-primary-color, &.vjs-selected": {
            color: "#fa225e !important"
        },
        "& .theo-player-wrapper > .theo-primary-background": {
            color: "#000000 !important",
            backgroundColor: "#fa225e !important"
        },
        "& .theo-player-wrapper > .theo-secondary-color": {
            color: "#ffffff !important"
        },
        "& .theo-player-wrapper > .theo-secondary-background": {
            color: "#000000 !important",
            backgroundColor: "#ffffff !important"
        },
        "& .theo-player-wrapper > .theo-tertiary-color": {
            color: "#000000 !important"
        },
        "& .theo-player-wrapper > .theo-tertiary-background": {
            color: "#ffffff !important",
            backgroundColor: "#000000 !important"
        },
        "&.theo-context-menu": {
            display: "none"
        },
        // Check specificity
        "& .theo-player-wrapper > .vjs-big-play-button": {
            width: "10%",
            paddingBottom: "10%"
        },
        // /* Set other image */
        "& .theo-player-wrapper > .vjs-big-play-button:before": {
            content: "' '",
            background: "url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjcycHgiIGhlaWdodD0iNzJweCIgdmlld0JveD0iMCAwIDcyIDcyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0My4yICgzOTA2OSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+dmlkZW8gaWNvbiBjb3B5IDQ8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iSG9tZXBhZ2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJIb21lcGFnZS1fZGVza3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQ3MC4wMDAwMDAsIC0zMDEyLjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iZnd0diIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIwLjAwMDAwMCwgMjc4OC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJiaWctdmlkZW8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMDAwMDAwLCA1MC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0idmlkZW8tMnB4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNTEuMDAwMDAwLCAxNzUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJ2aWRlby1jb3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNS4wMDAwMDAsIDM1LjAwMDAwMCkgcm90YXRlKC0zNjAuMDAwMDAwKSB0cmFuc2xhdGUoLTM1LjAwMDAwMCwgLTM1LjAwMDAwMCkgIj4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxjaXJjbGUgaWQ9Ik92YWwtMiIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiIGZpbGwtb3BhY2l0eT0iMC4xNSIgZmlsbD0iIzAwMDAwMCIgY3g9IjM1IiBjeT0iMzUiIHI9IjM1Ij48L2NpcmNsZT4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJUcmlhbmdsZSIgZmlsbD0iI0ZGRkZGRiIgcG9pbnRzPSIyNi45ODI4NTY5IDQ5Ljk1Mzc1MiAyNi45ODI4NTY5IDE5LjM0MjEwNTMgNDguNTQzNDU4OSAzMy45OTY5NDI5Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==') no-repeat 0 0",
            /* background: url('http://i.stack.imgur.com/LT3WE.png') no-repeat 0 0; */
            backgroundSize: "100%",
            display: "block"
        },
        /* Remove default THEOplayer image */
        "& .theo-player-wrapper > button > .theo-big-play-button-svg-container": {
            display: "none"
        },
        // /* Remove default spotlight around button on focus */
        "&:hover .theo-player-wrapper > .vjs-big-play-button:after, & .theo-player-wrapper > .vjs-big-play-button:focus:after": {
            opacity: 0
        },
        /* 16:9 aspect ratio */
        "&.video-js": {
            width: "100%",
            maxWidth: "100%",
            height: 0,
            paddingTop: "56.25%"
        }
    }
}));
const Tracking = (player, tracking, updateWatchedTime) => {
    let watchedDuration = 0;
    let timestamps = [];
    let currentTime = 0;
    const timestampLimit = 30;
    const trigger = () => {
        if (watchedDuration <= 0 || timestamps.length <= 1) {
            return;
        }
        const reportWatchedDuration = watchedDuration;
        watchedDuration = 0;
        timestamps = [];
        tracking.watchedReplay &&
            fetch(`/api/statistic/watchedReplay/${tracking.watchedReplay.sessionId}/${reportWatchedDuration}/${currentTime}`, Object.assign(Object.assign({}, ("keepalive" in new Request("") && { keepalive: true })), { method: HttpMethods.POST }));
        tracking.gaEvent &&
            pushGaEvent(Object.assign(Object.assign({}, tracking.gaEvent), { value: reportWatchedDuration }));
        if (currentTime > 0) {
            updateWatchedTime(currentTime);
        }
    };
    const onBeforeUnload = () => trigger();
    const onVisibilityChange = () => document.hidden && trigger();
    const onDestroy = () => {
        window.removeEventListener("beforeunload", onBeforeUnload);
        "hidden" in document && document.addEventListener("visibilitychange", onVisibilityChange);
        trigger();
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    "hidden" in document && document.addEventListener("visibilitychange", onVisibilityChange);
    player.addEventListener("destroy", onDestroy);
    player.addEventListener("loadstart", trigger);
    player.addEventListener("ended", trigger);
    player.addEventListener("seeked", trigger);
    player.addEventListener("timeupdate", () => {
        var _a, _b;
        const curTime = +player.currentTime.toFixed(0);
        currentTime = curTime;
        if (!((_b = (_a = player === null || player === void 0 ? void 0 : player.cast) === null || _a === void 0 ? void 0 : _a.chromecast) === null || _b === void 0 ? void 0 : _b.casting)) {
            curTime > 0 && timestamps.indexOf(curTime) < 0 && timestamps.push(curTime);
            watchedDuration = timestamps.length;
            if (timestamps.length >= timestampLimit) {
                trigger();
            }
        }
        else {
            trigger();
        }
    });
};
export const THEOPlayer = (props) => {
    const videoRef = useRef(null);
    const [loaded, setLoaded] = useState(false);
    const [canPlay, setCanPlay] = useState(false);
    const libraryLocation = "https://cdn.myth.theoplayer.com/d05ec07c-d90b-4892-8ec8-94fa062c69cc";
    useEffect(() => {
        if (!props.source || !loaded) {
            return;
        }
        const player = new window.THEOplayer.Player(videoRef.current, {
            libraryLocation,
            license: "sZP7IYe6T6Pl0Shc3oPlI6zrIDfrFSxg0l5-TS313OzL0lAK3l110S0o3S56FOPlUY3zWokgbgjNIOf9flhoIufrIux1FD0i3uB-3QBc06z_TSCrFS16CoaZ0oft3o4K0mfVfK4_bQgZCYxNWoryIQXzImf90SCz3Lfk0l5i0u5i0Oi6Io4pIYP1UQgqWgjeCYxgflEc3lacTufL3SfZ0uCtFOPeWok1dDrLYtA1Ioh6TgV6v6fVfKcqCoXVdQjLUOfVfGxEIDjiWQXrIYfpCoj-fgzVfKxqWDXNWG3ybojkbK3gflNWf6E6FOPVWo31WQ1qbta6FOPzdQ4qbQc1sD4ZFK3qWmPUFOPLIQ-LflNWfK1zWDikfgzVfG3gWKxydDkibK4LbogqW6f9UwPkIYz",
            allowNativeFullscreen: true,
            cast: {
                strategy: "auto",
                chromecast: { appID: props.receiverApplicationId }
            }
        });
        player.preload = "auto";
        player.source = props.source;
        props.tracking && Tracking(player, props.tracking, props.updateWatchedTime);
        if (props.playerRef) {
            props.playerRef.current = player;
        }
        player.addEventListener("readystatechange", ({ readyState }) => readyState === HTMLMediaElement.HAVE_ENOUGH_DATA && setCanPlay(true));
        player.addEventListener("error", (event) => {
            var _a, _b;
            // If errors occurs when playing HLS video. Fallback to mp4 format and reload.
            if (((_b = (_a = player.source) === null || _a === void 0 ? void 0 : _a.sources) === null || _b === void 0 ? void 0 : _b.type) === "application/x-mpegURL" && props.fallbackSource) {
                player.source = props.fallbackSource;
                player.load();
                player.start();
            }
        });
        window.setTimeout(() => {
            setCanPlay(true);
        }, 1000);
        if (props.startTime) {
            const setCurrentTime = () => {
                player.currentTime = props.startTime;
                player.removeEventListener("canplay", setCurrentTime);
            };
            player.addEventListener("canplay", setCurrentTime);
        }
        return () => {
            player.destroy();
            if (props.playerRef) {
                props.playerRef.current = null;
            }
        };
    }, [
        videoRef,
        loaded,
        props.source,
        props.tracking,
        props.receiverApplicationId,
        props.playerRef
    ]);
    useEffect(() => {
        let loadedScripts = 0;
        const scripts = [];
        scripts[0] = document.createElement("script");
        scripts[0].src = `${libraryLocation}/THEOplayer.js`;
        scripts[1] = document.createElement("script");
        scripts[1].src = "//www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
        scripts[2] = document.createElement("link");
        scripts[2].rel = "stylesheet";
        scripts[2].type = "text/css";
        scripts[2].href = `${libraryLocation}/ui.css`;
        scripts.forEach((v, i) => {
            document.head.appendChild(scripts[i]);
            scripts[i].onload = () => ++loadedScripts >= scripts.length && setLoaded(true);
        });
        return () => {
            scripts.forEach((v, i) => document.head.removeChild(scripts[i]));
        };
    }, []);
    const classes = useStyles({
        canPlay,
        image: props.poster
    });
    return (React.createElement("div", { className: classes.poster },
        React.createElement("div", { className: clsx(classes.container, "theoplayer-container video-js theoplayer-skin"), ref: videoRef })));
};
//# sourceMappingURL=THEOplayer.js.map